import { createSelector } from 'reselect';
import { getProjectLazy } from 'src/modules/common/selectors/getProjectLazy';

export const getEvaluationFormData = createSelector([
  getProjectLazy,
], (project) => project.data.evaluation);
